import React, { FunctionComponent } from "react";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

const CenteredArrowBackIosIcon: FunctionComponent<SvgIconProps> = (props) => {
	return (
		<SvgIcon {...props}>
			<path d="M 16.17 3.87 L 14.4 2.1 L 4.5 12 l 9.9 9.9 l 1.77 -1.77 L 8.04 12 z" />
		</SvgIcon>
	);
};

export default CenteredArrowBackIosIcon;